export class BlockStudent{
    blockId: number;
    studentId: number;
    institucionId: string;

    periodoId?: number;
}
